<template>
  <div>
    <div v-if="total != 0">
      <div>
        <el-table :data="DXtableData" style="width: 100%">
          <el-table-column prop="id" label="短信id">
          </el-table-column>
          <el-table-column prop="phone" label="手机号">
          </el-table-column>
          <el-table-column prop="send_reason" label="发送原因">
          </el-table-column>
          <el-table-column prop="send_content" label="发送内容" >
          </el-table-column>
          <el-table-column prop="send_status" label="状态">
          </el-table-column>
          <el-table-column prop="reason_for_receipt" label="回执">
          </el-table-column>
          <el-table-column prop="create_time" label="发送时间">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-else>
      <div class="baoqian1">抱歉,暂时没有信息!</div>
    </div>
  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from "../../product/product/part/spec/many/Table.vue";
export default {
  components: { Table },
  props: ["order_id"],
  data() {
    return {
      total: "",
      DXtableData:[]
    };
  },
  created() {
    let self = this;
    let Params = { order_id: self.order_id };
    FengkongApi.duanxin(Params, true).then((data) => {
      self.total = data.data.list.total;
      self.DXtableData = data.data.list.data;
    })

      .catch((error) => { });
  },

  methods: {},
};
</script>
  
<style>
.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.zhuangtai {
  color: #1890ff;
  font-size: 20px;
}

.sad {
  font-size: 20px;
  display: flex;
  justify-content: center;
}

.diyige {
  margin-top: 50px;
}

.yuqi {
  margin-top: 50px;
}

.yane {
  background-color: #f5f6f8;
}

</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/duanxinindex.vue